import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function UserTermsModal({ show, onHide, onConsentNo, onConsentYes }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="user-terms-modal"
            className='user-terms-modal'
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="acknowledgement">
                    Acknowledgement
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='mb-4'>Before submitting, read the following:</div>
                <div className='mb-4'>
                    I declare to the best of my knowledge that all information submitted is accurate, 
                    truthful, and in compliance with applicable regulations and laws
                </div>
                <hr/>
                <div>Ready to submit your application?</div>
            </Modal.Body>
            <Modal.Footer>
                <Button id='consentNo' className='consentNo' onClick={onConsentNo}>No</Button>
                <Button id='consentYes' className='consentYes' onClick={onConsentYes}>Yes, Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}


export default UserTermsModal;